/* eslint-disable */
var $ = window.jQuery = require('jquery');

import {
  mapGetters,
  mapState
} from 'vuex';

import draggable from "vuedraggable";
import toast from '@/services/toast';

export default {
  name: 'public-quiz-category',
  components: {
    draggable
  },
  props: [],
  data() {
    return {
      isActive: '',
      removeQuizId: '',
      categoryList: [],
      quizAnimationList: []
    }
  },
  computed: {
    ...mapGetters([
      'getCategoryListState',
      'getQuizAnimationState',
      'getcategoryDetailsByIdDataState'
    ]),
    getCategory() {
      this.categoryList = this.$store.getters.getCategoryListState;
      return this.categoryList
    },
    getQuizAnimation() {
      this.quizAnimationList = this.$store.getters.getQuizAnimationState;
      return this.quizAnimationList
    },
  },
  mounted() {
    this.getCategory
    this.getQuizAnimation
  },
  methods: {
    removeQuizAnimationPopup(quizId) {
      $('#removQuizModal').modal();
      this.removeQuizId = quizId;
    },
    quizBannerStatusAct(quizId) {
      let data = {
        id: quizId
      };
      this.$store.dispatch('getQuizAnimationListById', data)
        .then((res) => {
          if (res.data.code == '2000') {
            let status = this.$store.getters.getQuizAnimationByIdState.is_active;
            if (status === true) {
              this.isActive = false
            }
            if (status === false) {
              this.isActive = true
            }
            let data = {
              is_active: this.isActive,
            };
            this.$store.dispatch('updateQuizAnimationListById', {
                data: data,
                id: quizId
            }).then((res) => {
              if (res.status == '200') {
                this.geQuizAnimationListAgain();
                toast.success("Quiz Banner Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        }).catch((err) => {})
    },
    RemoveQuizConfirmationagain(){
      this.$store.dispatch('deleteQuizAnimationById', {
        id: this.removeQuizId
      }).then((res) => {
        this.geQuizAnimationListAgain()
      }).catch((err) => {})
    },
    geQuizAnimationListAgain() {
      this.$store.dispatch('getQuizAnimationList').then((res) => {
        this.QuizListDetails = this.$store.getters.getQuizAnimationState
      }).catch((err) => {})
    },
  },
  watch: {
    getCategory() {
      return this.$store.getters.getCategoryListState
    },
    getQuizAnimation() {
      return this.$store.getters.getQuizAnimationState
    }
  }
}
